import React from 'react';
import Countries from '~/components/countries_enum.ts';
import { getCzechArticleData } from '~/components/blog/article_service.ts';
import BlogArticle from '~/components/blog/article';

const Article = ({ articleLocales }) => {
    return (
        <BlogArticle
            articleLocales={articleLocales}
            country={Countries.CZECHIA}
        />
    );
};

export const getServerSideProps = async ({ query, res }) => {
    const articleData = await getCzechArticleData(query, Countries.CZECHIA);
    let articleLocales = JSON.stringify(articleData.articleWithLocales);

    const parsedArticles = JSON.parse(articleLocales);
    const dataForCurrentLang = parsedArticles[query.lang];
    const articleNotExists =
        dataForCurrentLang == [] || dataForCurrentLang == null;

    if (articleNotExists) {
        res.statusCode = 404;
        return { props: { articleLocales: JSON.stringify({}) } };
    }

    return {
        props: {
            articleLocales,
        },
    };
};

export default Article;
